import React from 'react';

import { Typography } from '@mui/material';

import { Field } from '@hrlogics/react-components/form';

import { SwitchField } from 'src/components/finalForm';

import { Labels } from './types';

interface NotificationSwitchProps {
  labels?: Labels;
  setting?: string;
}

export const NotificationSwitch: React.FC<NotificationSwitchProps> = ({ labels, setting }) => {
  if (!setting || !labels) {
    return null;
  }

  return (
    <Field
      name={setting}
      component={SwitchField}
      formControlLabelProps={{
        labelPlacement: 'start',
        sx: { justifyContent: 'space-between', gap: 1 },
      }}
      label={
        <React.Fragment>
          <Typography variant="subtitle1">{labels.title}</Typography>
          <Typography variant="body1" color="text.secondary">
            {labels.subtitle}
          </Typography>
        </React.Fragment>
      }
    />
  );
};
